








































































































































































































































































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { KunshanApplicationController } from '@/services/request.service';
import FormStep2 from '@/components/mixins/FormStep2';
import utils from '../utils';

@Component
export default class Step2 extends Mixins(FormStep2) {
  public isOneParent: boolean = false;
  public utils = utils;
  public isSource: boolean = false;
  public studentId: any = '';
  public draftId: any = '';
  public created() {
    this.isOneParent = this.config[this.school].defaultOneParent;
  }

  public get defaultOneParent() {
    return this.config[this.school].defaultOneParent;
  }

  public setFormContent(userInfo: any): void {
    const isDraft = this.$route.query.isDraft;
    const guardianResponse = userInfo.guardianResponse ? userInfo.guardianResponse : {};
    this.emergencyContactFlag =
      userInfo.emergencyContactResponse && JSON.stringify(userInfo.emergencyContactResponse) !== '{}'
        ? 'false'
        : 'true';
    if (this.defaultOneParent && JSON.stringify(guardianResponse) === '{}') {
      this.isOneParent = true;
    } else {
      this.isOneParent = false;
    }
    this.$nextTick(() => {
      this.applicationStep2Form.setFieldsValue(utils.formatDraftDataInStep2(userInfo));
    });
    if (userInfo && userInfo.sourceId && this.$route.query.studentId) {
      this.isSource = true;
    } else {
      this.isSource = false;
    }
    this.nameOfDefault = userInfo.name ? true : false;
    this.enNameOfDefault = userInfo.enName ? true : false;
    this.countryId = userInfo.countryId ? userInfo.countryId.toString() : undefined;
    this.areaCode = userInfo.areaCode || userInfo.accountAreaCode || '86';
    const res: any = this.$store.state.countryList.filter((item: any) => item.extraValue === this.areaCode);
    this.areaCodeKey = res.length > 0 ? res[0].key : this.areaCodeKey;
    this.sourceId = userInfo.sourceId; // 仅作schoolExtraValu placeholder提示使用
    this.sourceIsOther = this.config[this.school].showResourceExtraValue.includes(userInfo.sourceId) ? true : false;
    if (isDraft) {
      this.$nextTick(() => {
        this.applicationStep2Form.setFieldsValue({
          emergencyContactFlag: userInfo.emergencyContactFlag === false ? 'false' : 'true',
          sourceId: userInfo.sourceId ? userInfo.sourceId : undefined,
          remark: userInfo.remark ? userInfo.remark : undefined,
        });
      });
    }
  }

  public getStep2FormInfo(e: Event): any {
    e.preventDefault();
    this.applicationStep2Form.validateFieldsAndScroll((err: any, values: any) => {
      if (!err) {
        if (!values.name && !values.enName) {
          this.$message.error(this.$tc('applicationForm.tip1'));
        } else if (!this.isOneParent && !values.guardianName && !values.guardianEnName) {
          this.$message.error(this.$tc('applicationForm.tip1'));
        } else {
          values.areaCode = this.areaCode;
          if (!this.sourceIsOther) {
            values.sourceExtra = undefined;
          }
          this.$emit('changeStep', 'next', 'step2', values);
        }
      }
    });
  }

  public saveToDraft(e: Event): void {
    this.$emit('saveToDraft', true);
    const request = this.getDraftContent(e);
    (request.studentId = this.$route.query.studentId),
      (request.draftId = this.draftId),
      KunshanApplicationController.addDraft(request)
        .then(() => {
          this.$message.success(this.$tc('applicationForm.successSave'));
          this.$router.push({ name: 'home' });
        })
        .catch(() => {});
  }
}
